import React from "react";

const NewPlusIcon = ({ color = "#ffffff", size = "14" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
    >
      <path
        d="M1 8H15M8 1V15"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NewPlusIcon;
